import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  id: number,
 *  year: number,
 *  title: string,
 *  lastEdited: string,
 *  published: boolean }} QuestionnaireListItem
 */

/**
 * @typedef {{
 *  parentQuestionId: number,
 *  visibilityOperator: number,
 *  visibilityValueId: number }} VisibilityCondition
 */

/**
 * @typedef {{
 *  id: number,
 *  questionnaireId: number,
 *  text: string,
 *  descriptionText: string,
 *  answerValues: string[],
 *  required: boolean,
 *  visibilityLogic: VisibilityCondition[],
 *  isPublished: boolean }} Question
 */

/**
 * @typedef {{
 *  id: number,
 *  type: string,
 *  year: number,
 *  title: string,
 *  instructionText: string,
 *  isPublished: boolean,
 *  questions: Question[] }} Questionnaire
 */

const api = new Api("api/questionnaires");

/**
 * @returns {Promise<AxiosResponse<QuestionnaireListItem[]>>}
 */
export const getAll = () => api.get();

/**
 * @param {number} id
 * @returns {Promise<AxiosResponse<Questionnaire>>}
 */
export const getById = (id) => api.get(id);

/**
 * @param {number} year
 * @param {string} type
 * @param {number=} id
 * @returns {Promise<AxiosResponse<boolean>>}
 */
export const existsByYearAndType = (year, type, id = undefined) =>
  api.get(`exists/${year}/${type}`, { id });

export const create = (payload) => api.post("", payload);

export const update = (id, payload) => api.putId(id, payload);

export const remove = (id) => api.del(id);
